import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { DateTime } from "luxon";

// mui components
import { Box, InputLabel, Stack } from "@mui/material";

// custom components
import MaskedInput from "../../custom-input/masked-input";
import OutlinedTextInput from "../../custom-input/outlined-text-input";
import SecondarySelect from "../../custom-select/secondary-select";
import SSNInput from "../../custom-input/ssn-masked-input";
import CustomDivider from "../../custom-divider";
import Heading5 from "../../typography/heading-05";
import Heading6 from "../../typography/heading-06";

// mui icons
import { ErrorOutlined } from "@mui/icons-material";

// helper utils
import {
	maritalStatusOptions,
	stateOptions,
} from "../../../utils/select-options";
import {
	isEmptyOrUndefined,
	isNotNullAndUndefinedAndEmpty,
	isNullOrUndefinedOrEmpty,
} from "../../../utils/filter-value";
import { timeZoneOffset } from "../../../utils/timezone-offset";

// custom styles
import styles from "./index.module.scss";
import "./datepicker.scss";

const CreditBorrowerInformation = ({
	borrowerIndex,
	coBorrower,
	borrowerData,
	residenceIndex,
	residenceData,
	coBorrowerName,
	data,
	setLoanApplicationData,
	borrowerResidences,
	setBorrowerResidences,
	disabled,
	error,
}) => {
	const [ssnNumber, setSsnNumber] = useState("");
	const [cellPhone, setCellPhone] = useState("");

	const addressType =
		residenceData?.residencyType === "Current"
			? "current"
			: residenceData?.residencyType === "Prior"
			? "prior"
			: residenceData?.mailingAddressIndicator && "mail";

	useEffect(() => {
		console.log(
			"75 data ssn:",
			data[borrowerIndex]?.taxIdentificationIdentifier
		);

		setSsnNumber(data[borrowerIndex]?.taxIdentificationIdentifier);
		setCellPhone(data[borrowerIndex]?.mobilePhone);
	}, [data]);

	const handleSSN = (value) => {
		console.log("40 val:", value);
		setSsnNumber(value);

		console.log("45 data:", data);

		setLoanApplicationData(
			data.map((data, index) => {
				if (borrowerIndex === index) {
					return { ...data, taxIdentificationIdentifier: value };
				} else {
					return data;
				}
			})
		);
	};

	const handleCellPhone = (value) => {
		setCellPhone(value);
		setLoanApplicationData(
			data.map((data, index) => {
				if (borrowerIndex === index) {
					return { ...data, mobilePhone: value };
				} else {
					return data;
				}
			})
		);
	};

	const iso8601Pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

	const datepickerPattern =
		/^[A-Z][a-z]{2} [A-Z][a-z]{2} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([A-Za-z\s]+\)$/;

	function formatDateToMMDDYYYY(dateString) {
		console.log("125 dateString:", dateString);

		// Remove the day of the week and time zone name
		const cleanedDateString = dateString
			?.toString()
			.replace(/^(.*?\d{4}\s+\d{2}:\d{2}:\d{2}).*$/, "$1");

		// Parse the cleaned date string
		const parsedDate = DateTime.fromFormat(
			cleanedDateString,
			"EEE MMM dd yyyy HH:mm:ss",
			{ zone: "utc" }
		);

		// Format the parsed date to "MM-dd-yyyy hh:mm a" format
		const formattedDate = parsedDate.toFormat("yyyy-MM-dd");

		console.log("140 formatted date:", formattedDate);
		return formattedDate;
	}

	const handleBirthDate = (dateValue) => {
		console.log("100 date:", dateValue);

		setLoanApplicationData(
			data.map((data, index) => {
				if (borrowerIndex === index) {
					console.log("pattern iso 8601:", iso8601Pattern.test(dateValue));

					if (iso8601Pattern.test(dateValue)) {
						const formattedDate = timeZoneOffset(dateValue);
						console.log("130 formattedDate:", formattedDate);
						return { ...data, birthDate: formattedDate };
					}

					// Create a Date object from the date string
					const date = new Date(dateValue);
					// Get the year
					const year = date.getFullYear();
					console.log("160 year:", year);

					console.log("pattern custom:", datepickerPattern.test(dateValue));

					if (datepickerPattern.test(dateValue) && year > 1800) {
						const formattedDateTime = formatDateToMMDDYYYY(dateValue);

						console.log("160 formattedDateTime:", formattedDateTime);
						return { ...data, birthDate: formattedDateTime };
					}

					if (dateValue === null) {
						// clear btn clicked
						return { ...data, birthDate: undefined };
					}

					console.log("135 non-formatted date:", dateValue);
					return { ...data, birthDate: dateValue };
				} else {
					return data;
				}
			})
		);
	};

	const handleUpdateMail = (fieldKey, fieldValue) => {
		setBorrowerResidences(
			borrowerResidences.map((data, index) => {
				if (residenceIndex === index) {
					return { ...data, fieldKey: fieldValue };
				} else {
					return data;
				}
			})
		);
	};

	useEffect(() => {
		console.log("150 date:", data[borrowerIndex]?.birthDate);
		const dateValue = data[borrowerIndex]?.birthDate;

		console.log("150 match pattern:", iso8601Pattern.test(dateValue));

		if (iso8601Pattern.test(dateValue)) {
			setLoanApplicationData(
				data.map((data, index) => {
					if (borrowerIndex === index) {
						const formattedDate = timeZoneOffset(dateValue);

						console.log("200 formattedDate:", formattedDate);
						return { ...data, birthDate: formattedDate };
					} else {
						return data;
					}
				})
			);
		}
	}, [data, borrowerIndex]);

	useEffect(() => {
		if (coBorrower) {
			setLoanApplicationData(
				data.map((data, index) => {
					if (borrowerIndex === index) {
						return { ...data, hmdaNoCoApplicantIndicator: false };
					} else {
						return data;
					}
				})
			);
		}
	}, [coBorrower]);

	let labelText = `${coBorrower ? "co-borrower-" : "borrower-"}${
		addressType === "current"
			? "current-"
			: addressType === "prior"
			? "former-"
			: addressType === "mail" && "mailing-"
	}`;

	let showOnSubmitError =
		(!coBorrower || (coBorrower && !isEmptyOrUndefined(coBorrowerName))) &&
		error;

	return (
		<Box className={styles.cardContainer}>
			<Stack direction="column" className={styles.cardHeaderContainer}>
				<Heading5
					text={coBorrower ? "Co Borrower Information" : "Borrower Information"}
					fontType="semibold"
				/>

				{/* <Body3 text="Provide details about the borrower" /> */}
			</Stack>
			<Stack direction="column" className={styles.formSectionContainer}>
				{/* basic information */}
				<Stack direction="row" className={styles.inputSectionContainer}>
					{/* first name */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-first-name`}
						>
							<Heading6
								text="First Name"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							type="text"
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-first-name`}
							placeholder="First Name"
							value={data[borrowerIndex]?.firstName}
							handleChange={(event) =>
								setLoanApplicationData(
									data.map((data, index) => {
										if (borrowerIndex === index) {
											return { ...data, firstName: event.target.value };
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
							error={
								!coBorrower &&
								error &&
								(data[borrowerIndex]?.firstName === undefined ||
									data[borrowerIndex]?.firstName === "")
							}
							showEndIcon={
								!coBorrower &&
								error &&
								(data[borrowerIndex]?.firstName === undefined ||
									data[borrowerIndex]?.firstName === "")
							}
							endIcon={<ErrorOutlined className={styles.errorIcon} />}
						/>
					</Stack>

					{/* middle name */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-middle-name`}
						>
							<Heading6
								text="Middle Name"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							type="text"
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-middle-name`}
							placeholder="Middle Name"
							value={data[borrowerIndex]?.middleName}
							handleChange={(event) =>
								setLoanApplicationData(
									data.map((data, index) => {
										if (borrowerIndex === index) {
											return { ...data, middleName: event.target.value };
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
						/>
					</Stack>

					{/* last name */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-last-name`}
						>
							<Heading6
								text="Last Name"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							type="text"
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}outlined-input-last-name`}
							placeholder="Last Name"
							value={data[borrowerIndex]?.lastName}
							handleChange={(event) =>
								setLoanApplicationData(
									data.map((data, index) => {
										if (borrowerIndex === index) {
											return { ...data, lastName: event.target.value };
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
							error={
								error &&
								(coBorrower
									? isNotNullAndUndefinedAndEmpty(
											data[borrowerIndex]?.firstName
									  ) && isNullOrUndefinedOrEmpty(data[borrowerIndex]?.lastName)
									: isNullOrUndefinedOrEmpty(data[borrowerIndex]?.lastName))
							}
							showEndIcon={
								error &&
								(coBorrower
									? isNotNullAndUndefinedAndEmpty(
											data[borrowerIndex]?.firstName
									  ) && isNullOrUndefinedOrEmpty(data[borrowerIndex]?.lastName)
									: isNullOrUndefinedOrEmpty(data[borrowerIndex]?.lastName))
							}
							endIcon={<ErrorOutlined className={styles.errorIcon} />}
						/>
					</Stack>

					{/* marital status */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}select-marital-status`}
						>
							<Heading6
								text="Marital Status"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<SecondarySelect
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}select-marital-status`}
							displayEmpty={true}
							value={data[borrowerIndex]?.maritalStatusType || ""}
							handleChange={(event) =>
								setLoanApplicationData(
									data.map((data, index) => {
										if (borrowerIndex === index) {
											return {
												...data,
												maritalStatusType: event.target.value,
											};
										} else {
											return data;
										}
									})
								)
							}
							options={maritalStatusOptions}
							disabled={disabled}
							error={
								error &&
								(coBorrower
									? isNotNullAndUndefinedAndEmpty(
											data[borrowerIndex]?.firstName
									  ) &&
									  isNullOrUndefinedOrEmpty(
											data[borrowerIndex]?.maritalStatusType
									  )
									: isNullOrUndefinedOrEmpty(
											data[borrowerIndex]?.maritalStatusType
									  ))
							}
						/>
					</Stack>

					{/* date of birth */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}birth-date-picker`}
						>
							<Heading6
								text="Date of Birth"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<DatePicker
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}birth-date-picker`}
							className={
								disabled
									? styles.datepicker + " " + styles.disabledDatepicker
									: error &&
									  (coBorrower
											? isNotNullAndUndefinedAndEmpty(
													data[borrowerIndex]?.firstName
											  ) &&
											  isNullOrUndefinedOrEmpty(data[borrowerIndex]?.birthDate)
											: isNullOrUndefinedOrEmpty(
													data[borrowerIndex]?.birthDate
											  ))
									? styles.datepicker + " datepicker-error"
									: styles.datepicker
							}
							format="MM-dd-yyyy"
							value={
								data[borrowerIndex]?.birthDate !== undefined &&
								data[borrowerIndex]?.birthDate !== "" &&
								typeof data[borrowerIndex]?.birthDate === "string"
									? new Date(data[borrowerIndex]?.birthDate)
									: data[borrowerIndex]?.birthDate
							}
							onChange={handleBirthDate}
							disabled={disabled}
							maxDate={new Date()}
							error={
								error &&
								(coBorrower
									? isNotNullAndUndefinedAndEmpty(
											data[borrowerIndex]?.firstName
									  ) &&
									  isNullOrUndefinedOrEmpty(data[borrowerIndex]?.birthDate)
									: isNullOrUndefinedOrEmpty(data[borrowerIndex]?.birthDate))
							}
						/>
					</Stack>

					{/* primary phone number */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}masked-cell-phone`}
						>
							<Heading6
								text="Primary Phone Number"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<MaskedInput
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}masked-cell-phone`}
							placeholder="[XXX] XXX-XXXX"
							style={{
								border:
									error &&
									(coBorrower
										? isNotNullAndUndefinedAndEmpty(
												data[borrowerIndex]?.firstName
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.homePhoneNumber
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.workPhoneNumber
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.mobilePhone
										  ) &&
										  "3px solid #f00"
										: isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.homePhoneNumber
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.workPhoneNumber
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.mobilePhone
										  ) &&
										  "3px solid #f00"),
							}}
							type="phone"
							value={cellPhone}
							onInputChange={handleCellPhone}
							disabled={disabled}
						/>
					</Stack>

					{/* ssn */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel
							htmlFor={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}masked-input-ssn`}
						>
							<Heading6
								text="SSN"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<SSNInput
							id={`${
								coBorrower ? "co-borrower-" : "borrower-"
							}masked-input-ssn`}
							style={{
								border:
									error &&
									(coBorrower
										? isNotNullAndUndefinedAndEmpty(
												data[borrowerIndex]?.firstName
										  ) &&
										  isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.taxIdentificationIdentifier
										  ) &&
										  "3px solid #f00"
										: isNullOrUndefinedOrEmpty(
												data[borrowerIndex]?.taxIdentificationIdentifier
										  ) && "3px solid #f00"),
							}}
							placeholder="___-___-___"
							onUnmaskedSSNChange={handleSSN}
							disabled={disabled}
							unmaskedSSN={ssnNumber}
						/>
					</Stack>

					{/* Address Line 1 */}
					<Stack
						direction="column"
						className={styles.inputContainer + " " + styles.fullWidthContainer}
					>
						<InputLabel htmlFor={`${labelText}outlined-input-address-line`}>
							<Heading6
								text="Address Line 1"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							id={`${labelText}outlined-input-address-line`}
							type="text"
							placeholder="Street Line 1"
							fullWidth={true}
							value={residenceData?.uRLA2020StreetAddress || ""}
							handleChange={(event) =>
								setBorrowerResidences(
									borrowerResidences.map((data, index) => {
										if (residenceIndex === index) {
											handleUpdateMail(
												"uRLA2020StreetAddress",
												event.target.value
											);
											return {
												...data,
												uRLA2020StreetAddress: event.target.value,
											};
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
							error={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.uRLA2020StreetAddress)
							}
							showEndIcon={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.uRLA2020StreetAddress)
							}
							endIcon={<ErrorOutlined className={styles.errorIcon} />}
						/>
					</Stack>

					{/* Address Line 2 */}
					<Stack
						direction="column"
						className={styles.inputContainer + " " + styles.fullWidthContainer}
					>
						<InputLabel htmlFor={`${labelText}outlined-input-address-line-2`}>
							<Heading6
								text="Address Line 2 / Unit Number"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							id={`${labelText}outlined-input-address-line-2`}
							type="text"
							placeholder="Unit Number"
							fullWidth={true}
							value={residenceData?.addressUnitIdentifier || ""}
							handleChange={(event) =>
								setBorrowerResidences(
									borrowerResidences.map((data, index) => {
										if (residenceIndex === index) {
											handleUpdateMail(
												"addressUnitIdentifier",
												event.target.value
											);
											return {
												...data,
												addressUnitIdentifier: event.target.value,
											};
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
						/>
					</Stack>

					{/* city */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel htmlFor={`${labelText}outlined-input-city`}>
							<Heading6
								text="City"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							id={`${labelText}outlined-input-city`}
							type="text"
							placeholder="City"
							value={residenceData?.addressCity || ""}
							handleChange={(event) =>
								setBorrowerResidences(
									borrowerResidences.map((data, index) => {
										if (residenceIndex === index) {
											handleUpdateMail("addressCity", event.target.value);
											return {
												...data,
												addressCity: event.target.value,
											};
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
							error={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.addressCity)
							}
							showEndIcon={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.addressCity)
							}
							endIcon={<ErrorOutlined className={styles.errorIcon} />}
						/>
					</Stack>

					{/* state */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel htmlFor={`${labelText}select-state`}>
							<Heading6
								text={
									residenceData?.foreignAddressIndicator ? "Province" : "State"
								}
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						{residenceData?.foreignAddressIndicator ? (
							<OutlinedTextInput
								id={`${labelText}select-state`}
								type="text"
								placeholder="Province"
								value={residenceData?.addressState || ""}
								handleChange={(event) =>
									setBorrowerResidences(
										borrowerResidences.map((data, index) => {
											if (residenceIndex === index) {
												handleUpdateMail("addressState", event.target.value);
												return {
													...data,
													addressState: event.target.value,
												};
											} else {
												return data;
											}
										})
									)
								}
								disabled={disabled}
								error={
									showOnSubmitError &&
									isEmptyOrUndefined(residenceData?.addressState)
								}
								showEndIcon={
									showOnSubmitError &&
									isEmptyOrUndefined(residenceData?.addressState)
								}
								endIcon={<ErrorOutlined className={styles.errorIcon} />}
							/>
						) : (
							<SecondarySelect
								id="select-state"
								displayEmpty={true}
								value={residenceData?.addressState || ""}
								handleChange={(event) =>
									setBorrowerResidences(
										borrowerResidences.map((data, index) => {
											if (residenceIndex === index) {
												handleUpdateMail("addressState", event.target.value);
												return {
													...data,
													addressState: event.target.value,
												};
											} else {
												return data;
											}
										})
									)
								}
								options={stateOptions}
								disabled={disabled}
								error={
									showOnSubmitError &&
									isEmptyOrUndefined(residenceData?.addressState)
								}
							/>
						)}
					</Stack>

					{/* postal code */}
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel htmlFor={`${labelText}outlined-input-postal-code`}>
							<Heading6
								text={
									residenceData?.foreignAddressIndicator
										? "Postal Code"
										: "Zip Code"
								}
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							id={`${labelText}outlined-input-postal-code`}
							type="text"
							placeholder={
								residenceData?.foreignAddressIndicator
									? "Postal Code"
									: "Zip Code"
							}
							value={residenceData?.addressPostalCode || ""}
							handleChange={(event) =>
								setBorrowerResidences(
									borrowerResidences.map((data, index) => {
										if (residenceIndex === index) {
											handleUpdateMail("addressPostalCode", event.target.value);
											return {
												...data,
												addressPostalCode: event.target.value,
											};
										} else {
											return data;
										}
									})
								)
							}
							disabled={disabled}
							error={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.addressPostalCode)
							}
							showEndIcon={
								showOnSubmitError &&
								isEmptyOrUndefined(residenceData?.addressPostalCode)
							}
							endIcon={<ErrorOutlined className={styles.errorIcon} />}
						/>
					</Stack>
				</Stack>
			</Stack>

			<CustomDivider />
		</Box>
	);
};

export default CreditBorrowerInformation;
